import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Chunked upload shared by video / music / photo pickers.
export async function chunkedUpload(file, kind, onProgress = () => {}) {
  const init = await axios.post(`${API}/funtime/upload/init`, { filename: file.name, size: file.size, kind });
  const { upload_id, chunk_size } = init.data;
  const total = Math.ceil(file.size / chunk_size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, (i + 1) * chunk_size);
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", String(i));
    fd.append("chunk", blob, "chunk.bin");
    await axios.post(`${API}/funtime/upload/chunk`, fd);
    onProgress(Math.round(((i + 1) / total) * 90));
  }
  const done = await axios.post(`${API}/funtime/upload/complete`, { upload_id });
  onProgress(100);
  return done.data;
}

// Chunked upload for the shared File Transfer drop-box (any file type).
export async function transferUpload(file, deleteAfterDownload, onProgress = () => {}) {
  const init = await axios.post(`${API}/transfer/upload/init`, { filename: file.name, size: file.size });
  const { upload_id, chunk_size } = init.data;
  const total = Math.ceil(file.size / chunk_size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, (i + 1) * chunk_size);
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", String(i));
    fd.append("chunk", blob, "chunk.bin");
    await axios.post(`${API}/transfer/upload/chunk`, fd);
    onProgress(Math.round(((i + 1) / total) * 90));
  }
  const done = await axios.post(`${API}/transfer/upload/complete`, { upload_id, delete_after_download: deleteAfterDownload });
  onProgress(100);
  return done.data;
}

// Authenticated download: fetch as blob with the axios auth header (works even
// when cookies are blocked, e.g. embedded previews), then save via object URL.
export async function downloadFile(url, filename) {
  const res = await axios.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([res.data]));
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
}

export { API };
